import { Text, Image } from '@betty/moonlight';
import { memo } from 'react';
import styles from './AboutUsItem.module.css';
import { AboutUsItemType } from '../AboutUsSection.constants';

function AboutUsItem({item}: { item: AboutUsItemType }) {
  return (
    <div className={styles.aboutUsCard}>
      <Image name={item.imgSrc}
        height={{
          desktop: 108,
          tablet: 108,
          mobile: 78,
        }}
        aspectRatio={1}
         />
      <Text variant="h6" color="darkSurfacePrimary" textAlign="center">
        {item.title}
      </Text>
      <Text variant="body-m" color="darkSurfacePrimary" textAlign="center">
        {item.description}
      </Text>
    </div>
  );
}

export default memo(AboutUsItem);
